import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {get as _get} from 'lodash';


import {getLink} from '@modules/app/components/Link';
import {convertToInt} from '@utils/helpers';
import mapModulesToProps from '@utils/mapModulesToProps';
import {PRODUCT_SPOTT} from '@constants/variables';

import ClientProductForm from './ClientProductForm';
import {deleteSuccessCallback, setClientProductsEntity} from '../utils/clientProducts';

class ClientProductSpottForm extends ClientProductForm {
    componentDidMount() {
        super.componentDidMount();

        const entityName = 'client',
            params = {
                clientData: this.props.clientData,
                entityName,
                setEntity: this.props.Entity.setEntity,
            };

        this.setCreateSuccessCallback((response) => {
            this.props.Entity.setEntity({
                name: entityName,
                data: {...this.props.clientData,
                    clientProducts: this.props.clientData.clientProducts.concat(
                        response.data.createClientProductSpott.client_product
                    ),
                },
            });

            this.props.history.push(getLink('clients.products.spott.editGeoRestrictions', {
                id: this.props.match.params.id,
            }));
        });

        this.setUpdateSuccessCallback((response) => {
            const clientProductSpottIndex = this.props.clientData.clientProducts.findIndex(clientProduct =>
                    PRODUCT_SPOTT === convertToInt(clientProduct.product.id)
                ),
                clientProducts = {};

            clientProducts[clientProductSpottIndex] = {
                ...response.data.updateClientProductSpott.client_product,
            };
            params.clientProducts = clientProducts;

            setClientProductsEntity(params);
        });

        this.setDeleteSuccessCallback(() => {
            params.formParamsId = this.props.formParams.id;
            params.historyPush = this.props.history.push;

            deleteSuccessCallback(params);
        });
    }

    componentDidUpdate(prevProps) {
        const {
            formParams,
            GraphQLEntityData,
            GraphQLOptionsData,
        } = this.props;

        const isAddForm = _get(formParams, 'isAddForm');
        const clientProductsSpott = _get(GraphQLEntityData, 'clientProductsSpott', []);
        const entityLoading = _get(GraphQLEntityData, 'loading', false);
        const optionsProduct = _get(GraphQLOptionsData, 'product');
        const optionsLoading = _get(GraphQLOptionsData, 'loading', false);
        let augmentedPrevProps = prevProps;

        if (!optionsLoading && !entityLoading && !this.state.dataReceived) {
            if (!isAddForm && 0 < clientProductsSpott.length) {
                augmentedPrevProps = { ...prevProps, clientProduct: clientProductsSpott[0].client_product };

                this.setField('id', {defaultValue: convertToInt(clientProductsSpott[0].id)});
            }

            this.handleInitialSlaFieldVisibility(isAddForm, clientProductsSpott, optionsProduct);
            super.componentDidUpdate(augmentedPrevProps);
        }
    }

    prepareDataForSubmit(data) {
        data = {...data, product: PRODUCT_SPOTT};

        const dataToSubmit = super.prepareDataForSubmit(data);

        return {...dataToSubmit,
            is_spott_synchronization_disabled: !!data.is_spott_synchronization_disabled,
        };
    }
}

const mapDispatchToProps = mapModulesToProps(['Entity']),
    mapStateToProps = (state) => ({clientData: state.app.entities.client || null});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClientProductSpottForm));
